export class CalendarDayEvent {
  public readonly name: string;
  public readonly comment?: string;

  constructor(name: string, comment?: string) {
    this.name = name;
    this.comment = comment;
  }
}
